import { render, staticRenderFns } from "./MenuTopEsp.vue?vue&type=template&id=ff2bab18&scoped=true&"
import script from "./MenuTopEsp.vue?vue&type=script&lang=js&"
export * from "./MenuTopEsp.vue?vue&type=script&lang=js&"
import style0 from "./MenuTopEsp.vue?vue&type=style&index=0&id=ff2bab18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2bab18",
  null
  
)

export default component.exports